import { render, staticRenderFns } from "./LRouterTabs.vue?vue&type=template&id=72d22c86&scoped=true"
import script from "./LRouterTabs.vue?vue&type=script&lang=js"
export * from "./LRouterTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d22c86",
  null
  
)

export default component.exports